<app-menu>
    <div class="header">
        <h1>Get Rates</h1>
    </div>
    <div class="body">
        <div class="input-div" [formGroup]="searchForm">
            <div class="input-div-section">
                <h2>Customer</h2>
                <div>
                    <app-contact-autocomplete 
                    placeholder="Search customer..." 
                    [type]="'customer_contact_list'" 
                    [formControl]="customerNameControl" 
                    (selected)="onCustomerSelected($event)"
                    style="max-width: 50%;"
                    ></app-contact-autocomplete>
                    <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                        <mat-label>Customer Profile</mat-label>
                        <mat-select formControlName="customerProfileUuid">
                            <mat-option *ngFor="let p of customerProfiles" [value]="p.value">
                                {{p.label}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <!-- <mat-checkbox formControlName="notExistingCustomer">This is not an existing customer</mat-checkbox> -->
                </div>
            </div>
            <div class="input-div-section">
                <h2>Origin</h2>
                <span>Please select an existing contact and address or enter a postal/zip code.</span>
                <div class="input-row">
                    <app-contact-autocomplete 
                    placeholder="Search contact..." 
                    [type]="'shipper_contact_list'" 
                    [formControl]="shipperNameControl" 
                    (selected)="onShipperSelected($event)"
                    style="max-width: 50%;"
                    ></app-contact-autocomplete>
                    <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                        <mat-label>Origin Address</mat-label>
                        <mat-select formControlName="originAddressUuid">
                            <mat-option *ngFor="let a of shipperAddresses" [value]="a.value">
                                {{a.label}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                        <mat-label>Postal/Zip Code</mat-label>
                        <input matInput type="text" formControlName="originPostalCode">
                    </mat-form-field>
                </div>
            </div>
            <div class="input-div-section">
                <h2>Destination</h2>
                <span>Please select an existing contact and address or enter a postal/zip code.</span>
                <div class="input-row">
                    <app-contact-autocomplete 
                    placeholder="Search contact..." 
                    [type]="'consignee_contact_list'" 
                    [formControl]="consigneeNameControl" 
                    (selected)="onConsigneeSelected($event)"
                    style="max-width: 50%;"
                    ></app-contact-autocomplete>
                    <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                        <mat-label>Origin Address</mat-label>
                        <mat-select formControlName="destinationAddressUuid">
                            <mat-option *ngFor="let a of consigneeAddresses" [value]="a.value">
                                {{a.label}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                        <mat-label>Postal/Zip Code</mat-label>
                        <input matInput type="text" formControlName="destinationPostalCode">
                    </mat-form-field>
                </div>
            </div>
            <mat-expansion-panel class="input-div-section" [expanded]="true">
                <mat-expansion-panel-header>Load</mat-expansion-panel-header>
                <div [class]="'load-forms dynamic-form-array-container'" formArrayName="load">
                    <button mat-raised-button (click)="addPalletProduct()">Add Pallets</button>
                    <mat-card *ngFor="let l of load.controls; let i = index" [formGroupName]="i">
                        <div class="dynamic-card-header">
                            <button mat-icon-button color="warn" (click)="removePalletProduct(i)" matTooltip="Delete this item">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                        <mat-error *ngIf="l.hasError('palletOrDimsNotSet') && (l.touched || l.dirty)">
                            Please fill out pallet dimensions or number of pallets.
                        </mat-error>
                        <div>
                            <mat-form-field>
                                <mat-label>Number of Pallets</mat-label>
                                <input type="number" matInput formControlName="number">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Weight</mat-label>
                                <input type="number" matInput formControlName="weight">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Length</mat-label>
                                <input type="number" matInput formControlName="length">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Width</mat-label>
                                <input type="number" matInput formControlName="width">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Height</mat-label>
                                <input type="number" matInput formControlName="height">
                            </mat-form-field>
                        </div>
                    </mat-card>
                </div>
            </mat-expansion-panel>
            <button mat-raised-button color="primary" (click)="searchRates()">Search Rates</button>
            <button mat-stroked-button color="primary" (click)="resetSearchForm()">Clear Form</button>
        </div>
        <form [formGroup]="customerBillableForm">
            <h1>Results</h1>
            <mat-form-field>
                <mat-label>Billable Rate</mat-label>
                <input matInput formControlName="billable_rate">
            </mat-form-field>
            <!-- <mat-form-field>
                <mat-label>Billable Rate Type</mat-label>
                <input matInput formControlName="default_customer">
            </mat-form-field> -->
            <mat-form-field>
                <mat-label>Transit Days</mat-label>
                <input matInput formControlName="transit_days">
            </mat-form-field>
        </form>
        <ag-grid-angular 
            class="ag-theme-ulaap" 
            [rowData]="rowData" 
            [columnDefs]="columnDefs"
            (gridReady)="onGridReady($event)"   
            style="width:70%; height:200px"  
        >
        </ag-grid-angular>
        <ag-grid-angular 
            class="ag-theme-ulaap" 
            [rowData]="historicMarketRowData" 
            [columnDefs]="historicMarketColDefs"
            style="width:80%; height:200px" 
        ></ag-grid-angular>
    </div>
    <!-- Old code below -->
    <div style="display: none">
        <span>For demo purposes, this page was hardcoded to get rates for Technogym/CRST.</span>
        <form [formGroup]="form">
            <div>
                <h2>Organizations</h2>
                <mat-form-field>
                    <mat-label>Customer</mat-label>
                    <input matInput  
                        [matAutocomplete]="customerAutocomplete" formControlName="customer_name">
                </mat-form-field>
                <mat-autocomplete #customerAutocomplete="matAutocomplete" (optionSelected)="onOptionSelected($event, 'customer')">
                    <mat-option *ngFor="let item of filteredCustomerList" [value]="item.contact_organization" style="border-bottom: 1px solid black">
                        <span>{{item.contact_organization}}</span>
                    </mat-option>
                </mat-autocomplete>
                <mat-form-field>
                    <mat-label>Carrier</mat-label>
                    <input matInput  
                        [matAutocomplete]="carrierAutocomplete" formControlName="carrier_name">
                </mat-form-field>
                <mat-autocomplete #carrierAutocomplete="matAutocomplete" (optionSelected)="onOptionSelected($event, 'carrier')">
                    <mat-option *ngFor="let item of filteredCarrierList" [value]="item.contact_organization" style="border-bottom: 1px solid black">
                        <span>{{item.contact_organization}}</span>
                    </mat-option>
                </mat-autocomplete>
            </div>
            <div>
                <h2>Origin Location</h2>
                <h5>Please fill in either city/province or postal code.</h5>
                <mat-form-field>
                    <mat-label>City</mat-label>
                    <input matInput formControlName="origin_city"/>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Province/State</mat-label>
                    <input matInput formControlName="origin_region" maxlength="2">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Postal/Zip Code</mat-label>
                    <input matInput formControlName="origin_postal" maxlength="6">
                </mat-form-field>
            </div>
            <div>
                <h2>Destination Location</h2>
                <h5>Please fill in either city/province or postal code.</h5>
                <!-- <mat-form-field>
                    <mat-label>Location Type</mat-label>
                    <mat-select formControlName="destination_type">
                        <mat-option *ngFor="let type of location_types" [value]="type">
                            {{type.replace('_', ' ')}}
                        </mat-option>
                    </mat-select>
                </mat-form-field> -->
                <mat-form-field>
                    <mat-label>City</mat-label>
                    <input matInput formControlName="destination_city"/>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Province/State</mat-label>
                    <input matInput formControlName="destination_region" maxlength="2">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Postal/Zip Code</mat-label>
                    <input matInput formControlName="destination_postal" maxlength="6">
                </mat-form-field>
            </div>
            <div>
                <h2>Load Information</h2>
                <mat-form-field>
                    <mat-label>Rate Type</mat-label>
                    <mat-select formControlName="rate_metric">
                        <mat-option *ngFor="let metric of rate_metrics; let i = index" [value]="i+1">
                            {{metric}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Measurement Number</mat-label>
                    <input matInput type="number" formControlName="measurement">
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Measurement Unit</mat-label>
                    <mat-select formControlName="rate_unit">
                        <mat-option *ngFor="let unit of rate_units; let i = index" [value]="i+1">
                            {{unit}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </form>
        <button mat-raised-button color="primary" (click)="search()">Search</button>
        <button mat-raised-button (click)="resetForm()">Clear Form</button>
        <form [formGroup]="results_form">
            <h1>Results</h1>
            <mat-form-field>
                <mat-label>Billable Rate</mat-label>
                <input matInput formControlName="customerRate">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Billable Rate Type</mat-label>
                <input matInput formControlName="default_customer">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Cost Rate</mat-label>
                <input matInput formControlName="carrierRate">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Cost Rate Type</mat-label>
                <input matInput formControlName="default_carrier">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Transit Time (Days)</mat-label>
                <input matInput formControlName="transit_days">
            </mat-form-field>
        </form>
    </div>
</app-menu>